import { render, staticRenderFns } from "./QuestionnaireFormQuestionDate.vue?vue&type=template&id=52d39b72"
import script from "./QuestionnaireFormQuestionDate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormQuestionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports